import { apiSlice } from '../../api/api-slice';
import { AddCardRequest } from 'types/card/card-list';

export const creatCards = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addCard: builder.mutation<void, AddCardRequest>({
            query: (addCardRequest: AddCardRequest) => ({
                url: `/card/add-card/` + addCardRequest.personageId,
                method: 'POST',
                body: { ...addCardRequest },
            }),
        }),
    }),
});
export const { useAddCardMutation } = creatCards;
